import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import React from 'react';
import { Stack } from '../../../Stack/Stack';
import { Spacing } from '@front/sharedcomponents/Variables';
import { Style, StyleContext, StyleState } from '@components/WebDesktop/Style';
import { TooltipDecorator } from '../../../Tooltip/TooltipDecorator';
import { TooltipBehavior } from '../../../Tooltip/TooltipTypes';
export const NumericContainer = ({ children, className = '', disabled = false, validationError }) => {
    const containerClassName = [
        'numeric',
        Style.Secondary,
        StyleContext.Input,
        disabled ? StyleState.Disabled : '',
        isValidString(validationError) ? StyleState.Error : '',
        className
    ]
        .filter(Boolean)
        .join(' ');
    return (React.createElement(TooltipDecorator, { behavior: TooltipBehavior.Error, content: validationError },
        React.createElement(Stack, { className: containerClassName, spacing: Spacing.None }, children)));
};
NumericContainer.displayName = 'NumericContainer';
